import RecipeDetail from './components/recipe/RecipeDetail.js';
export default RecipeDetail;